import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import CategoryDropdown from "@/pages/home/components/CategoryDropdown";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import WhatIsSection from "@/pages/home/components/WhatIsSection";
import BenefitsSection from "@/pages/home/components/BenefitsSection";
import ComparisonSection from "@/pages/home/components/ComparisonSection";
import ArticleSection from "@/pages/home/components/ArticleSection";
import Footer from "@/pages/home/components/Footer";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "OOPBuy Spreadsheet Deutschland – Finde die besten Produkte schneller",
  description: "Entdecke aktuelle OOPBuy Spreadsheet Listen, Produktvergleiche und Experten-Guides. Spare Zeit bei der Produktsuche und finde geprüfte Produkte einfacher.",
  url: "https://oopbuyspread.forum/",
  publisher: { "@type": "Organization", name: "OOPBuy Spreadsheet Deutschland" },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "OOPBuy Spreadsheet Deutschland",
  url: "https://oopbuyspread.forum/",
  description: "Die deutsche Informationsplattform für OOPBuy Spreadsheet Listen, Produktvergleiche und Experten-Guides.",
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryGrid />
      <WhatIsSection />
      <BenefitsSection />
      <ComparisonSection />
      <ArticleSection />
      <Footer />
    </main>
  );
}